import { useSession } from "next-auth/react";
import { useIntercom } from "react-use-intercom";

interface ImpersonateUser {
    email: string;
    ro_id: string;
}

const useImpersonate = () => {
    const { update, data } = useSession();
    const impersonatedUser = data?.impersonatedUser;
    const { boot, shutdown } = useIntercom();

    const startImpersonating = async ({ ro_id, email }: ImpersonateUser) => {
        localStorage.removeItem("transactionFilter");
        await update({ impersonatedUser: { ro_id, email } });
        shutdown();
    };

    const stopImpersonating = async () => {
        localStorage.removeItem("transactionFilter");
        await update({ stopImpersonating: true });
        boot({
            email: data?.user.email ?? undefined,
            name: data?.user.name ?? undefined,
        });
    };

    return {
        impersonatedUser,
        startImpersonating,
        stopImpersonating,
    };
};

export default useImpersonate;
